import { render } from "./B2bPageOcrDocument.vue?vue&type=template&id=1938ba6e&scoped=true&lang=pug"
import script from "./B2bPageOcrDocument.vue?vue&type=script&lang=js"
export * from "./B2bPageOcrDocument.vue?vue&type=script&lang=js"

import "./B2bPageOcrDocument.vue?vue&type=style&index=0&id=1938ba6e&lang=scss&scoped=true"
import "./B2bPageOcrDocument.vue?vue&type=style&index=1&id=1938ba6e&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1938ba6e"]])

export default __exports__